import { render, staticRenderFns } from "./DetailTracer.vue?vue&type=template&id=03a60d5b&scoped=true&"
import script from "./DetailTracer.vue?vue&type=script&lang=js&"
export * from "./DetailTracer.vue?vue&type=script&lang=js&"
import style0 from "./DetailTracer.vue?vue&type=style&index=0&id=03a60d5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a60d5b",
  null
  
)

export default component.exports